// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.image_in_kpf_table_container {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 5px;
  max-width: 100%;
}
.image_in_kpf_table_container .img_in_kpf_table {
  width: 100px;
  height: 100px;
}
.image_in_kpf_table_container .img_in_kpf_table img {
  width: 100%;
  min-width: 100%;
  height: auto;
}

tfoot {
  color: gray;
}

tfoot th {
  font-weight: normal;
}

.resizer {
  position: absolute;
  right: 0;
  top: 0;
  height: 100%;
  width: 5px;
  background: rgba(0, 0, 0, 0.5);
  cursor: col-resize;
  -webkit-user-select: none;
          user-select: none;
  touch-action: none;
}

.resizer.isResizing {
  background: blue;
  opacity: 1;
}

@media (hover: hover) {
  .resizer {
    opacity: 0;
  }
  *:hover > .resizer {
    opacity: 1;
  }
}
th,
td {
  word-wrap: break-word;
  -webkit-hyphens: auto;
          hyphens: auto;
}

.kpF_table td {
  border-bottom: 1px solid rgba(88, 89, 93, 0.2078431373);
}

.tr_border-both td {
  border-top: 1px solid rgba(88, 89, 93, 0.2078431373);
  border-bottom: 1px solid rgba(88, 89, 93, 0.2078431373);
}

.kpf_table_tr {
  cursor: pointer;
}

.tr_border-bottom td {
  border: 0;
  border-bottom: 1px solid rgba(88, 89, 93, 0.2078431373);
}

.tr_border-side td {
  border: 0;
  border-left: 1px solid rgba(88, 89, 93, 0.2078431373);
  border-right: 1px solid rgba(88, 89, 93, 0.2078431373);
}

.tr_border-top td {
  border: 0;
  border-top: 1px solid rgba(88, 89, 93, 0.2078431373);
}

.tr_no_border td {
  border: 0;
  border-top: 0;
  border-bottom: 0;
}

.td_kpf_header td {
  background: rgba(218, 225, 236, 0.5411764706);
}`, "",{"version":3,"sources":["webpack://./src/Components/KP/kp-f/kpFinTable/kpFinTable.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EAEA,uBAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;AAAF;AACE;EAEE,YAAA;EAEA,aAAA;AADJ;AAEI;EACE,WAAA;EACA,eAAA;EACA,YAAA;AAAN;;AAgCA;EACE,WAAA;AA7BF;;AAgCA;EACE,mBAAA;AA7BF;;AAgCA;EACE,kBAAA;EACA,QAAA;EACA,MAAA;EACA,YAAA;EACA,UAAA;EACA,8BAAA;EACA,kBAAA;EACA,yBAAA;UAAA,iBAAA;EACA,kBAAA;AA7BF;;AAgCA;EACE,gBAAA;EACA,UAAA;AA7BF;;AAgCA;EACE;IACE,UAAA;EA7BF;EAgCA;IACE,UAAA;EA9BF;AACF;AAiCA;;EAEE,qBAAA;EACA,qBAAA;UAAA,aAAA;AA/BF;;AAmCE;EACE,uDAAA;AAhCJ;;AAwCE;EACE,oDAAA;EACA,uDAAA;AArCJ;;AAyCA;EACE,eAAA;AAtCF;;AAyCE;EACE,SAAA;EACA,uDAAA;AAtCJ;;AA0CE;EACE,SAAA;EACA,qDAAA;EACA,sDAAA;AAvCJ;;AA2CE;EACE,SAAA;EACA,oDAAA;AAxCJ;;AA4CE;EACE,SAAA;EACA,aAAA;EACA,gBAAA;AAzCJ;;AA8CE;EACE,6CAAA;AA3CJ","sourcesContent":[".image_in_kpf_table_container {\n  display: flex;\n  // width: 100%;\n  justify-content: center;\n  align-items: center;\n  gap: 5px;\n  max-width: 100%;\n  .img_in_kpf_table {\n    // flex: 2 1 auto;\n    width: 100px;\n    // max-width: 100%;\n    height: 100px;\n    img {\n      width: 100%;\n      min-width: 100%;\n      height: auto;\n    }\n  }\n}\n// .kpf_table {\n//   tbody {\n//     tr {\n//       border-bottom: 1px solid #426ca63b;\n//       &:hover {\n//         background-color: #426ca62f;\n//       }\n//       &:last-child {\n//         border-bottom: 0;\n//       }\n//     }\n//   }\n//   thead {\n//     tr {\n//       background-color: #426ca61d;\n//     }\n//   }\n//   td {\n//     white-space: break-spaces;\n//     text-align: left;\n//     /* Запрет переноса текста на новую строку */\n//     overflow: hidden; /* Скрытие текста, выходящего за пределы ячейки */\n//     text-overflow: ellipsis;\n\n//     background-color: #03070c1f;\n//   }\n// }\n\ntfoot {\n  color: gray;\n}\n\ntfoot th {\n  font-weight: normal;\n}\n\n.resizer {\n  position: absolute;\n  right: 0;\n  top: 0;\n  height: 100%;\n  width: 5px;\n  background: rgba(0, 0, 0, 0.5);\n  cursor: col-resize;\n  user-select: none;\n  touch-action: none;\n}\n\n.resizer.isResizing {\n  background: blue;\n  opacity: 1;\n}\n\n@media (hover: hover) {\n  .resizer {\n    opacity: 0;\n  }\n\n  *:hover > .resizer {\n    opacity: 1;\n  }\n}\n\nth,\ntd {\n  word-wrap: break-word;\n  hyphens: auto;\n}\n\n.kpF_table {\n  td {\n    border-bottom: 1px solid #58595d35;\n  }\n}\n\n.imgBox {\n}\n\n.tr_border-both {\n  td {\n    border-top: 1px solid #58595d35;\n    border-bottom: 1px solid #58595d35;\n  }\n}\n\n.kpf_table_tr {\n  cursor: pointer;\n}\n.tr_border-bottom {\n  td {\n    border: 0;\n    border-bottom: 1px solid #58595d35;\n  }\n}\n.tr_border-side {\n  td {\n    border: 0;\n    border-left: 1px solid #58595d35;\n    border-right: 1px solid #58595d35;\n  }\n}\n.tr_border-top {\n  td {\n    border: 0;\n    border-top: 1px solid #58595d35;\n  }\n}\n.tr_no_border {\n  td {\n    border: 0;\n    border-top: 0;\n    border-bottom: 0;\n    // border-top: 1px solid #58595d35;\n  }\n}\n.td_kpf_header {\n  td {\n    background: #dae1ec8a;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
